<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-center class="text-xs-center">
      <v-flex xs12 md4 v-if="timer">
        <!-- Title -->
        <v-layout justify-center class="margin-bottom">
          <v-flex shrink>
            <v-icon :color="project.color" small>fas fa-square-full</v-icon>
          </v-flex>
          <v-flex
            shrink
            class="font-weight-black title mx-2"
            :to="{ name: 'home' }"
          >
            <router-link :to="{ name: 'projectView', params: { projectId } }">
              {{ project.data.name }}
            </router-link>
          </v-flex>
        </v-layout>

        <v-flex class="font-weight-thin display-3 margin-bottom">
          {{ durationText }}
        </v-flex>
        <!-- Controls -->

        <v-layout
          v-if="!isStopped"
          justify-center
          align-center
          class="margin-bottom"
        >
          <v-flex shrink>
            <v-btn flat v-if="timer.status == 'PAUSED'" @click="onClear">
              clear
            </v-btn>
          </v-flex>

          <v-flex shrink>
            <v-btn
              fab
              v-if="timer.status != 'RUNNING'"
              class="elevation-2"
              @click="onStart"
            >
              <v-icon>far fa-play-circle</v-icon>
            </v-btn>
            <v-btn
              fab
              v-if="timer.status == 'RUNNING'"
              class="elevation-2"
              @click="onPause"
            >
              <v-icon>far fa-pause-circle</v-icon></v-btn
            >
          </v-flex>

          <v-flex shrink>
            <v-btn flat v-if="timer.status == 'PAUSED'" @click="onStop">
              Stop
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout column v-if="isStopped" class="text-xs-right">
          <v-flex>
            <v-textarea solo label="Notes" v-model="note"></v-textarea>
          </v-flex>
          <v-layout>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <v-btn flat @click="isStopped = false">
                Cancel
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn color="primary" @click="onSave">
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { Time } from "@/lib/Time";
export default {
  data() {
    return {
      duration: 0,
      note: "",
      isStopped: false,
      updateInterval: undefined
    };
  },
  mounted() {
    this.updateInterval = setInterval(this.updateDuration, 300);
  },
  destroyed() {
    clearInterval(this.updateInterval);
  },
  computed: {
    ...mapState(["timerReader", "recordReader", "projectReader"]),
    timer() {
      if (this.timerReader.ready) {
        return this.timerReader.getByProjectId(this.$route.params.projectId);
      }
      return undefined;
    },
    projectId() {
      return this.$route.params.projectId;
    },
    project() {
      if (this.projectReader.ready) {
        return this.projectReader.getByProjectId(this.$route.params.projectId);
      }
      return undefined;
    },
    durationText() {
      let hour = Time.duration.as(this.duration, Time.unit.hour, true);
      let min = Time.duration.get(this.duration, Time.unit.minute);
      let sec = Time.duration.get(this.duration, Time.unit.second);
      return `${hour} H ${min} M ${sec} S`;
    }
  },
  watch: {
    timer: {
      immediate: true,
      handler() {
        this.updateDuration();
      }
    }
  },
  methods: {
    updateDuration() {
      this.duration = this.timer ? this.timer.elapsedTime : 0;
    },
    onPause() {
      this.timer.pause();
      this.updateDuration();
    },
    onStart() {
      this.timer.start();
      this.updateDuration();
    },
    onClear() {
      this.timer.clear();
      this.updateDuration();
    },
    onStop() {
      this.isStopped = true;
    },
    onSave() {
      let record = this.recordReader.create(this.$route.params.projectId);
      record.updateData(this.timer.exportRecordData());
      record.updateData({
        UTCOffset: Time.date.getUTCOffSet(),
        note: this.note
      });
      this.timer.stop();
      record.save();
      this.$router.push({
        name: "projectView",
        params: { projectId: this.$route.params.projectId }
      });
    }
  }
};
</script>

<style scoped>
.margin-bottom {
  margin-bottom: 50px;
}
</style>
